import { useQuery } from "@tanstack/react-query";

import { generateResilienceInsight } from "services";

import { GET_SCENARIO_RESILIENCE_INSIGHT } from "consts";

import { ResilienceInsightRequest } from "models";

type UseGetScenarioResilienceInsightParams = {
  scenarioId: string;
  /** Null until the active scenario has a resilience result ... query stays disabled. */
  requestBody: ResilienceInsightRequest | null;
  enabled?: boolean;
};

export const useGetScenarioResilienceInsight = ({ scenarioId, requestBody, enabled = true }: UseGetScenarioResilienceInsightParams) =>
  useQuery({
    queryKey: [GET_SCENARIO_RESILIENCE_INSIGHT, scenarioId, requestBody],
    queryFn: ({ signal }) => generateResilienceInsight({ requestBody: requestBody!, signal }),
    enabled: enabled && !!requestBody,
    staleTime: Infinity,
    retry: false, // fall back to topOpportunity(); don't retry-storm
  });
